module.exports = __webpack_public_path__ + "assets/img/block-hover-e2c342c6.png";